import { render, staticRenderFns } from "./LoginMynex.vue?vue&type=template&id=4ddb4d72&"
import script from "./LoginMynex.vue?vue&type=script&lang=js&"
export * from "./LoginMynex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports